import { lazy, type LazyExoticComponent, type ComponentType } from 'react';

type LazyPage = LazyExoticComponent<ComponentType<any>>;

export interface RouteConfig {
    path?: string;
    index?: boolean;
    element?: LazyPage;
    children?: RouteConfig[];
    redirect?: string;
}

/*
|--------------------------------------------------------------------------
| Lazy Pages
|--------------------------------------------------------------------------
*/

export const pages = {
    // Community
    community: lazy(() => import('../pages/community/Community')),
    // communitySaved: lazy(() => import('../pages/Commuinty/SavedPage')),
    // communityFriends: lazy(() => import('../pages/Commuinty/Friends')),
    // communityGroups: lazy(() => import('../pages/Commuinty/Groups')),
    // communityPages: lazy(() => import('../pages/Commuinty/Pages')),
    // communityMemories: lazy(() => import('../pages/Commuinty/MemoriesPage')),
    // communityMarketplace: lazy(() => import('../pages/Commuinty/Marketplace')),

    // facebookReels: lazy(
    //     () => import('../pages/Commuinty/FacebookReels')
    // ),

    // facebookMessenger: lazy(
    //     ()=> import('../pages/Commuinty/Massenger')
    // ),

    // profile: lazy(
    //     () => import('../pages/Commuinty/ProfilePage')
    // ),

    // showGroup: lazy(
    //     () => import('../pages/Commuinty/ShowGroup')
    // ),

    // createGroup: lazy(
    //     () => import('../pages/Commuinty/CreateGroup')
    // ),

    // showPage: lazy(
    //     () => import('../pages/Commuinty/ShowPage')
    // ),

    // createPage: lazy(
    //     () => import('../pages/Commuinty/CreatePage')
    // ),

    // notifications: lazy(
    //     () => import('../pages/Commuinty/NotificationsPage')
    // ),

    // messenger: lazy(
    //     () => import('../pages/Commuinty/Massenger')
    // ),

    // // Jobs
    // jobsHome: lazy(
    //     () => import('../pages/Commuinty/Jobs/HomePage')
    // ),

    // browseJobs: lazy(
    //     () => import('../pages/Commuinty/Jobs/BrowseJobsPage')
    // ),

    // jobDetail: lazy(
    //     () => import('../pages/Commuinty/Jobs/JobDetailPage')
    // ),

    // browseTalent: lazy(
    //     () => import('../pages/Commuinty/Jobs/BrowseTalentPage')
    // ),

    // talentProfile: lazy(
    //     () => import('../pages/Commuinty/Jobs/TalentProfilePage')
    // ),

    // postJob: lazy(
    //     () => import('../pages/Commuinty/Jobs/PostJobPage')
    // ),

    // createProfile: lazy(
    //     () => import('../pages/Commuinty/Jobs/CreateProfilePage')
    // ),

    // applications: lazy(
    //     () => import('../pages/Commuinty/Jobs/MyApplicationsPage')
    // ),

    // Market
    mainCurrencies: lazy(
        () => import('../pages/market/MainCurrencies')
    ),

    crossCurrencies: lazy(
        () => import('../pages/market/CrossCurrencies')
    ),

    indexCurrencies: lazy(
        () => import('../pages/market/IndexCurrencies')
    ),

    metals: lazy(
        () => import('../pages/market/Metals')
    ),

    crypto: lazy(
        () => import('../pages/market/Crypto')
    ),

    indicator: lazy(
        () => import('../pages/market/Indicator')
    ),

    stock: lazy(
        () => import('../pages/market/Stock')
    ),

    energy: lazy(
        () => import('../pages/market/Energy')
    ),

    gold: lazy(
        () => import('../pages/gold')
    ),

    bank: lazy(
        () => import('../pages/market/BankTable')
    ),

    currency: lazy(
        () => import('../pages/market/CurrencyTable')
    ),

    // Broker
    // broker: lazy(
    //     () => import('../pages/Broker/Broker')
    // ),

    // brokerView: lazy(
    //     () => import('../pages/Broker/BrokerView')
    // ),

    // brokerDetail: lazy(
    //     () => import('../pages/Broker/BrokerDetail')
    // ),

    // scam: lazy(
    //     () => import('../pages/Broker/Scam')
    // ),

    // brokerComparison: lazy(
    //     () => import('../pages/Broker/BrokerComparison')
    // ),

    // brokerRating: lazy(
    //     () => import('../pages/Broker/FinancialIntermediaries')
    // ),

    // rating: lazy(
    //     () => import('../pages/Broker/RatingView')
    // ),

    // cryptoExchange: lazy(
    //     () => import('../pages/Broker/CryptoExchangePage')
    // ),

    // exchange: lazy(
    //     () => import('../pages/Broker/ExchangePage')
    // ),

    // proTrading: lazy(
    //     () => import('../pages/Broker/ProbTreading')
    // ),

    // Store
    // store: lazy(
    //     () => import('../pages/Store/Index')
    // ),

    // product: lazy(
    //     () => import('../pages/Store/Product')
    // ),

    // checkout: lazy(
    //     () => import('../pages/Store/Checkout')
    // ),

    // cart: lazy(
    //     () => import('../pages/Store/Cart')
    // ),

    // wishlist: lazy(
    //     () => import('../pages/Store/Whishlist')
    // ),

    // opinion: lazy(
    //     () => import('../pages/Store/Openion')
    // ),

    // Tools
    // calendar: lazy(
    //     () => import('../pages/Tools/CalendarTable')
    // ),

    // signals: lazy(
    //     () => import('../pages/Tools/Signles')
    // ),

    // webinar: lazy(
    //     () => import('../pages/Tools/Webiner')
    // ),

    // toolsOpinion: lazy(
    //     () => import('../pages/Tools/ToolsOpinionBlog')
    // ),

    // currencyExchange: lazy(
    //     () => import('../pages/TraderTools/pages/CurrencyExchange')
    // ),

    // pipCalculator: lazy(
    //     () => import('../pages/TraderTools/pages/PipCalculator')
    // ),

    // marginCalculator: lazy(
    //     () => import('../pages/TraderTools/pages/MarginCalculator')
    // ),

    // profitLoss: lazy(
    //     () => import('../pages/TraderTools/pages/ProfitLoss')
    // ),

    // positionSize: lazy(
    //     () => import('../pages/TraderTools/pages/PositionSize')
    // ),

    // Promotion
    // cashbackPromotion: lazy(
    //     () => import('../pages/Promotion/PromotionCashback')
    // ),

    // bonusPromotion: lazy(
    //     () => import('../pages/Promotion/PromotionBounce')
    // ),

    // competition: lazy(
    //     () => import('../pages/Promotion/Competition')
    // ),

    // competitionDetails: lazy(
    //     () => import('../pages/Promotion/CompetitionDetails')
    // ),

    // realAccount: lazy(
    //     () => import('../pages/Promotion/RealAccount')
    // ),

    // demoAccount: lazy(
    //     () => import('../pages/Promotion/DemoAccount')
    // ),

    // olxPrize: lazy(
    //     () => import('../pages/Promotion/OlxPrize')
    // ),

    // AI
    // expertAdvisors: lazy(
    //     () => import('../pages/ExpertAdvisors')
    // ),

    // performance: lazy(
    //     () => import('../pages/ExpertAdvisors/pages/Performance')
    // ),

    // summary: lazy(
    //     () => import('../pages/ExpertAdvisors/pages/Summary')
    // ),

    // userSignals: lazy(
    //     () => import('../pages/UserSignals')
    // ),

    // telegramSignals: lazy(
    //     () => import('../pages/TelegramSignals')
    // ),

    // P2P
    // marketplace: lazy(
    //     () => import('../pages/p2p/MarketPlacePage')
    // ),

    // orderHistory: lazy(
    //     () => import('../pages/p2p/OrderHistoryPage')
    // ),

    // orderDetails: lazy(
    //     () => import('../pages/p2p/OrderDetialsPage')
    // ),

    // wallet: lazy(
    //     () => import('../pages/p2p/P2PWalletPage')
    // ),

    // disputes: lazy(
    //     () => import('../pages/p2p/P2PDisputesPage')
    // ),

    // p2pProfile: lazy(
    //     () => import('../pages/p2p/P2PProfilePage')
    // ),

    // p2pChat: lazy(
    //     () => import('../pages/p2p/P2PChatPage')
    // ),
};